import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { SignInForm, SignUpForm } from './AuthForms';

/**
 * Account dialog used at checkout: a returning visitor with a pending basket can create an
 * account (default) or sign in, then the payment continues automatically.
 */
export const AuthDialog = ({ open, onOpenChange, onAuthenticated, defaultMode = 'signup', intro }) => {
  const [mode, setMode] = useState(defaultMode);
  const done = (c) => { onOpenChange(false); onAuthenticated?.(c); };
  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (v) setMode(defaultMode); }}>
      <DialogContent data-testid="checkout-auth-dialog" className="bg-nw-espresso border-nw-gold/25 text-nw-ivory max-w-md max-h-[92vh] overflow-y-auto p-8 sm:p-10">
        <DialogTitle className="sr-only">Account</DialogTitle>
        <DialogDescription className="sr-only">Create an account or sign in to continue.</DialogDescription>
        <div className="font-serif text-nw-gold text-lg tracking-[0.28em] text-center mb-6">NICEWINE</div>
        {mode === 'signup'
          ? <SignUpForm idPrefix="dialog-signup" intro={intro} onSuccess={done} onSwitch={() => setMode('signin')} />
          : <SignInForm idPrefix="dialog-signin" onSuccess={done} onSwitch={() => setMode('signup')} />}
      </DialogContent>
    </Dialog>
  );
};
